import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    baseUrl:
      process.env.NODE_ENV === "production"
        ? "/"
        : "https://www.la-gamelle.test/",
    api:
      process.env.NODE_ENV === "production"
        ? "/wp-json/gamelle/v1"
        : "https://www.la-gamelle.test/wp-json/gamelle/v1",
    recipes: [],
    categories: [],
    endpoints: []
  },
  mutations: {},
  actions: {}
});
